import EditableContainerBase from "Lib/Fs.SmartClient.Client/EditableContainerBase";
import SortBy from "Lib/Fs.Core.Data/SortBy";
import PagingCriteria from "Lib/Fs.Core.Data/PagingCriteria";
import SortingCriteria from "Lib/Fs.Core.Data/SortingCriteria";
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger } from "aurelia-validation";
import { useView, autoinject, Container } from 'aurelia-framework'

export default class CommonSearchVMBase extends EditableContainerBase {
    SortingCriteria: SortingCriteria;
    PagingCriteria: PagingCriteria;
    ItemCount: number = 0;
    PageIndex: number = 0;
    PageSize: number = 10;
    PageNumberSize: number = 5;
    EnablePaging: boolean = true;
    GridPageIndexList: string[];
    PageNumberIndex: number;
    PageNumberList: any[] = [];

    get PageCount() {
        if (this.PageSize == 0 || this.ItemCount == 0 || this.PageSize == null) return 0;
        var roundingValue = this.ItemCount / this.PageSize;
        var roundedValue = Math.round(roundingValue);
        return roundingValue > roundedValue ? roundedValue + 1 : roundedValue;
    }

    get MaxPageNumbers() {
        if (this.PageCount == 0 || this.PageNumberSize == 0 || this.PageNumberSize == null) return 0;
        var roundingValue = this.PageCount / this.PageNumberSize;
        var roundedValue = Math.round(roundingValue);
        return roundingValue > roundedValue ? roundedValue + 1 : roundedValue;
    }

    validationController: ValidationController;
    constructor() {
        super();
        this.SortingCriteria = new SortingCriteria();
        var validationControllerFactory = Container.instance.get(ValidationControllerFactory);
        this.validationController = validationControllerFactory.createForCurrentScope();
    }

    Search(isChangePage: boolean = false) {
    }

    RemoveItems(items: any[]) {
        throw "This function has not yet been implemented.";
    };

    AddItems(items: any[]) {
        throw "This function has not yet been implemented.";
    };

    AddItem(item: any) {
        throw "This function has not yet been implemented.";
    };

    RemoveItem(item: any) {
        throw "This function has not yet been implemented.";
    };

    PageChanged(currentPage: number) {
        this.PageIndex = currentPage;
        this.Search(true);
    }

    GeneratePageNumberList() {

        var pageNumber = Math.floor(this.PageIndex / this.PageNumberSize);

        this.PageNumberList = [];
        this.PageNumberIndex = pageNumber;

        let pageGeneratedCount = this.PageNumberSize;

        if ((this.PageNumberIndex + 1) >= this.MaxPageNumbers) {
            if (this.PageCount == 0) {
                pageGeneratedCount = 1;
            } else {
                pageGeneratedCount = this.PageCount % this.PageNumberSize == 0 ? this.PageNumberSize : this.PageCount % this.PageNumberSize;
            }
        }

        for (let i = 0; i < pageGeneratedCount; i++) {
            var pageIndex = (this.PageNumberIndex * this.PageNumberSize) + i;
            this.PageNumberList.push({
                PageIndex: pageIndex,
                DisplayPage: pageIndex + 1
            });
        }
    }

    validateErrors: any[];

    getValidateErrors(key: string) {
        if (this.validationController.errors.length == 0) return []
        var filter = this.validationController.errors.filter(function (t) {
            return t.propertyName === key;
        });
        if (filter.length == 0) return [];
        var map = filter.map(function (t) {
            return t.message;
        });
        return map;
    }

    getDisplayNameValidateErrors(key: string) {
        if (this.validationController.errors.length == 0) return []
        var filter = this.validationController.errors.filter(function (t) {
            return t.rule.property.displayName === key;
        });
        if (filter.length == 0) return [];
        var map = filter.map(function (t) {
            return t.message;
        });
        return map;
    }

    ValidateData() {
        this.validationController.validate({ object: this });
    };


    Validate() {
        if (this.validationController.errors.length > 0) {
            return false;
        } else {
            return true;
        }
    }
}
